import { createFileRoute } from '@tanstack/react-router';
import { dashboardSummaryQuery } from '@/api/queries/dashboard';
import { DashboardScreen } from '@/features/dashboard/DashboardScreen';

export const Route = createFileRoute('/_app/dashboard')({
  // Start the summary request alongside the screen's code (and on hover of
  // a link to here), without holding the navigation for it: the screen shows
  // its header straight away and the figures as soon as they land.
  loader: ({ context }) => {
    void context.queryClient.prefetchQuery(dashboardSummaryQuery);
  },
  component: DashboardScreen,
});
